var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"neo-form-builder flex h-full flex-col"},[(_vm.data)?_c('form-builder',{attrs:{"data":_vm.data,"gapErrors":"{}"},on:{"submit":_vm.saveForm}}):_c('div',{staticClass:"w-full h-full flex items-center justify-center bg-blue-50"},[_c('loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }